export default {
  prevSlideText: {
    id: 'product_page_verified_refurbished_carousel_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'product_page_verified_refurbished_carousel_next_slide',
    defaultMessage: 'Display next slide',
  },
} as const
